import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatNativeDateModule } from '@angular/material/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { DxAccordionModule } from 'devextreme-angular/ui/accordion';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';

import { StorageService } from './services/storage.service';
import { MainCoreFactory } from './core/factory.mainCore';
import { AuthService } from './services/account/auth.service';
import { JwtAuthInterceptor } from './interceptors/jwt-auth.interceptor';

import { PdsDxDataGridComponent } from './components/pds/pds-dx-data-grid.component';
import { PdsDxDataGridService } from './services/pds/pds-dx-data-grid.service';
import { PdsDxDateService } from './services/pds/pds-dx-date.service';

import { AppComponent } from './components/app/app.component';
import { AppService } from './services/core/app.service';
//import { AppBaseModule } from './app-base.module';
//import { AppRoutingBaseModule } from './app-routing-base.module';
import { PdsHasAccessDirective } from './directives/layout/pds-has-access.directive';
import { UserAccountComponent } from './components/layout/user-account.component';
import { LayoutFactory } from './data/layout/factory.layout';
import { ApiService } from './services/data/api.service';
import { DialogService } from './services/core/dialog-service';
import { PermissionsService } from './services/account/permissions.service';

import { NavMenuComponent } from './components/navmenu/navmenu.component';

import { LoginComponent } from './components/account/login.component';
import { ForgotPasswordComponent } from './components/account/forgot-password.component';
import { ResetPasswordComponent } from './components/account/reset-password.component';
import { ResetYourPasswordComponent } from './components/account/reset-your-password.component';
import { AppSettingsService } from './services/core/app-settings.service';
import { ScriptService } from './services/core/script.service';
import { CssService } from './services/core/css.service';
import { LoadingModule } from './modules/loading/loading.module';

@NgModule({
    //bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        PdsDxDataGridComponent, PdsHasAccessDirective,
        NavMenuComponent,
        LoginComponent, ForgotPasswordComponent, ResetPasswordComponent, ResetYourPasswordComponent, UserAccountComponent,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule, ReactiveFormsModule,
        RouterModule,
        FlexLayoutModule,
        //BrowserAnimationsModule,
        MatIconModule, MatSidenavModule, MatNativeDateModule,
        DxAccordionModule, DxButtonModule, DxDrawerModule, DxScrollViewModule, DxTemplateModule, DxTextBoxModule, DxToolbarModule,
        LoadingModule
        //AppRoutingBaseModule
    ],
    exports: [AppComponent, PdsHasAccessDirective],
    providers: [AppSettingsService, AppService, AuthService, ApiService, CssService, DialogService, /*NavMenuService, */ ScriptService, StorageService
        , MainCoreFactory, LayoutFactory, PdsDxDataGridService, PdsDxDateService, PermissionsService,
        {
            provide: HTTP_INTERCEPTORS, useClass:
                JwtAuthInterceptor, multi: true
        }
    ]
})

export class AppBaseSharedModule {
}